import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const COOKIE_DAYS = 60;

/**
 * Hook to detect ?ref=AFFILIATE_CODE in URL and set a 60-day cookie.
 * Also tracks the click on the backend.
 * If the page is visited WITHOUT ?ref=, clears any existing affiliate cookie
 * to prevent stale referrals from being attributed.
 */
export const useAffiliateTracking = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const refCode = searchParams.get('ref');
    
    if (refCode) {
      // Set cookie
      const expires = new Date();
      expires.setDate(expires.getDate() + COOKIE_DAYS);
      document.cookie = `sd_affiliate_ref=${refCode}; expires=${expires.toUTCString()}; path=/; SameSite=Lax`;

      // Track click on backend
      axios.post(`${API_URL}/api/affiliates/track-click`, {
        affiliate_code: refCode,
        page_visited: window.location.pathname,
        referrer: document.referrer || null
      }).catch(() => {});
    } else if (window.location.pathname.includes('costa-rica') || window.location.pathname.includes('/retreats')) {
      // If visiting the retreat page WITHOUT ?ref=, clear any stale affiliate cookie
      // This prevents purchases from being attributed to a previous referral
      document.cookie = 'sd_affiliate_ref=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Lax';
    }
  }, [searchParams]);
};

/**
 * Get the stored affiliate code from cookie (used during checkout/purchase)
 */
export const getAffiliateCode = () => {
  const match = document.cookie.match(/sd_affiliate_ref=([^;]+)/);
  return match ? match[1] : null;
};
